export default "__VITE_ASSET__CfsB$dE8__"